import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext, useSiteSelection } from "@context";
import { useOfficialData, useManagerData } from "@hooks";
import { DashBanner, OfficialGrid } from "@components";
import { ROLES } from "@constants/roles";
import DashBreadcrumb from "./DashBreadcrumb";
import "./dash.css";

const Official = () => {
    const { auth } = useContext(AuthContext);
    const { compCode, siteCode } = useSiteSelection();
    const isAdminOrR1 = auth?.role === ROLES.SUPER_ADMIN || auth?.roleId === 'R1';

    const params = compCode ? { compCode: compCode } : {};
    const { data, refetch } = useOfficialData(params);
    const { data: managerData } = useManagerData(compCode ? { compCode: compCode } : {});

    if (!compCode) {
        return <Navigate to={isAdminOrR1 ? "/dash/company" : "/dash/site"} replace />;
    }
    if (!siteCode) {
        return <Navigate to="/dash/site" replace />;
    }

    return (
        <>
            <DashBreadcrumb />

            <div className="contents-wrap">
                <DashBanner
                    title="중대재해 현장 이해관계자"
                    description="관련 법령에 따른 안전보건 관리 책임자 및 관리 감독자 등 현장별 핵심 이해관계자의 명단과 담당 직무를 확인합니다."
                />
                {data && (
                    <OfficialGrid
                        roleList={data.commonRoleInfo}
                        roleEmpInfo={data.companyInfo}
                        data={data.gridData}
                        siteCodes={data.siteDTO}
                        sizeCategory={data.sizeCategory}
                        compCode={compCode}
                        selectedSite={siteCode}
                    />
                )}
            </div>
            {managerData?.managerName && (
                <div className="dash-manager-info">
                    <span>담당자&nbsp;&nbsp;<strong>{managerData.managerName}</strong></span>
                    <span>연락처&nbsp;&nbsp;<strong>{managerData.managerPhone}</strong></span>
                </div>
            )}
        </>
    );
};

export { Official };
